import { Reducer } from 'redux';
import { createSelector } from 'reselect';
import { USER_LOGGED_IN } from './user';

export const UPDATE_STORE_DATA_STATE = 'UPDATE_STORE_DATA_STATE';

type DataState = 'empty' | 'stale' | 'fresh';
type Action =
  | { type: typeof USER_LOGGED_IN }
  | { type: typeof UPDATE_STORE_DATA_STATE; data: DataState }
  | { type: '' };

const dataState: Reducer<DataState, Action> = (state = 'empty', action) => {
  switch (action.type) {
    case USER_LOGGED_IN:
      return 'empty';
    case UPDATE_STORE_DATA_STATE:
      return action.data;
    default:
      return state;
  }
};

export default dataState;

// SELECTORS

const rootSelector = (rootState: { dataState: DataState }): DataState => rootState.dataState;
export const isStoreDataLoaded = createSelector(rootSelector, (state) => state !== 'empty');
export const isStoreDataFresh = createSelector(rootSelector, (state) => state === 'fresh');
